import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-home\"><defs><style type=\"text/css\"></style></defs><path d=\"M837.644 584.682c-19.291 0-34.929 15.638-34.929 34.929v329.238h-574.543v-329.238c0-19.29-15.638-34.929-34.929-34.929s-34.929 15.638-34.929 34.929v364.167c0 19.29 15.638 34.929 34.929 34.929h644.401c19.29 0 34.929-15.638 34.929-34.929v-364.167c0-19.29-15.638-34.929-34.929-34.929z\" p-id=\"1705\" /><path d=\"M1005.291 447.673l-466.569-436.505c-13.41-12.545-34.246-12.565-47.679-0.045l-468.31 436.526c-14.111 13.153-14.887 35.255-1.735 49.366 6.88 7.379 16.206 11.111 25.559 11.111 8.529 0 17.077-3.105 23.808-9.379l444.45-414.286 442.748 414.222c14.086 13.179 36.189 12.443 49.37-1.644 13.18-14.085 12.444-36.188-1.642-49.369z\" p-id=\"1706\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home.svg
// module id = U9Ws
// module chunks = 3